import * as React from 'react'

export function InlineHoverAction({
  children,
  actionText = 'Reset',
  icon,
  onAction,
  className = '',
  buttonClassName = '',
  ariaLabel,
  title,
}: {
  children: React.ReactNode
  actionText?: React.ReactNode
  icon?: React.ReactNode
  onAction: () => void
  className?: string
  buttonClassName?: string
  ariaLabel?: string
  title?: string
}) {
  return (
    <span className={`group inline-flex items-center gap-2 ${className}`}>
      <span className="t-sm text-primary">{children}</span>

      <button
        type="button"
        onClick={onAction}
        className={[
          'opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition',
          't-sm text-highlight inline-flex items-center gap-1 px-1 py-0.5 -m-1 rounded',
          buttonClassName,
        ].join(' ')}
        aria-label={ariaLabel}
        title={title}
      >
        {icon}
        {actionText}
      </button>
    </span>
  )
}
